import { SystemUserfeature } from "features/systemUserManagement/domain/entities/SystemUserResponseEntity";
import { CacheKeyEnum } from "utils/enums/CacheKeyEnum";

export class AuthenticationResponseEntity {
  address?: string;
  avatar?: string;
  balance?: number;
  birthDay?: string;
  name?: string;
  createdAt?: string;
  description?: string;
  email?: string;
  fullName?: string;
  id?: string;
  isAdmin?: boolean;
  isAffiliate?: boolean;
  isModerator?: boolean;
  partner?: string | Array<string>;
  partners?: Array<string>;
  phone?: string;
  username?: string;
  role?: { name?: string; code?: string };
  // numeric type from backend: 3 = merchant, 5 = store, 4 = staff
  type?: number;
  accessToken?: {
    id?: string;
    ttl?: number;
    createdAt?: string;
    expiredAt?: number | string;
  };
  authenticateToken?: {
    token?: string;
    ttl?: number;
    created?: string;
    expired?: number;
  };
  features?: SystemUserfeature[];
  updatedAt?: string;
  code?: string;
  status?: number;
  note?: string;
  order?: string;
  isValidIp?: boolean;
  configuration?: any;

  saveAuthenToken?(
    isSavedForNextLogin: boolean,
    data: AuthenticationResponseEntity,
  ) {
    isSavedForNextLogin
      ? localStorage.setItem(
          CacheKeyEnum.mainToken,
          data?.authenticateToken.token,
        )
      : sessionStorage.setItem(
          CacheKeyEnum.mainToken,
          data?.authenticateToken?.token,
        );
    delete data.authenticateToken;
  }
}
